<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card dashboard-card">
        <div class="card-header">
          <h4>Todays Appointment</h4>
          <p>Your Personal Badminton Schedule</p>
        </div>
        <div class="appointment-info">
          <ul>
            <li>
              <div class="appointment-item">
                <div class="appointment-img">
                  <img src="@/assets/img/booking/booking-01.jpg" alt="Appointment" />
                </div>
                <div class="appointment-content">
                  <h6>Court Name</h6>
                  <p>Standard Synthetic Court 1</p>
                </div>
              </div>
            </li>
            <li>
              <h6>Appointment Date</h6>
              <p>Mon, Jul 11</p>
            </li>
            <li>
              <h6>Start Time</h6>
              <p>05:25 AM</p>
            </li>
            <li>
              <h6>Appointment End Time</h6>
              <p>06:25 AM</p>
            </li>
            <li>
              <h6>Additional Guests</h6>
              <p>4</p>
            </li>
            <li>
              <h6>Location</h6>
              <p>Sant Marco</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
